import React, { FunctionComponent, useState, useEffect } from "react";
import Inputs, { InputsGroup } from "../../Components/Inputs";
import { getCatalogs } from "actions/catalogs";
import { getViews } from "actions/vista";

type FormReporteProps = {
  item: any;
  action: string;
  errors: any;
  handleOnChange: (e: any) => void;
};

const FormReporte: FunctionComponent<FormReporteProps> = ({
  item,
  action,
  errors,
  handleOnChange,
}) => {
  const [reportsParent, setReportsParent] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [status, setStatus] = useState([]);

  console.log("item", item);

  useEffect(() => {
    handleReportsParent();
    handleReportTypes();
    handleStatus();
  }, []);

  const handleReportTypes = () => {
    getCatalogs("segVistaTbl", "idTipoReporte").then((res) => {
      if (res) {
        res = res.filter((item: any) => item.valor > 0);

        res.unshift({
          valor: 0,
          descripcion: "Seleccionar",
        });

        setReportTypes(
          res.map((e: any) => {
            return {
              value: e.valor,
              text: e.descripcion,
            };
          }),
        );
      }
    });
  };

  const handleReportsParent = () => {
    getViews(0, "0").then((res) => {
      if (res) {
        res = res.filter((item: any) => item.idTipoVista < 3);

        res.unshift({
          idVista: 0,
          descripcion: "Seleccionar",
        });

        setReportsParent(
          res.map((e: any) => {
            return {
              value: e.idVista,
              text: e.descripcion,
            };
          }),
        );
      }
    });
  };

  const handleStatus = () => {
    const statusList: any = [
      { value: 1, text: "Activo" },
      { value: 0, text: "Inactivo" },
    ];
    setStatus(statusList);
  };

  const renderInputs = () => {
    return (
      <>
        <InputsGroup>
          <>
            <Inputs
              id={"codigoVista"}
              label={"Código"}
              type={"text"}
              value={item?.codigoVista}
              handleOnChange={handleOnChange}
              className={`input ${errors["codigoVista"] ? "input_error" : ""}`}
              errorMessage={errors["codigoVista"]}
            />
            <Inputs
              id={"descripcionMenu"}
              label={"Descripción Menu"}
              type={"text"}
              value={item?.descripcionMenu}
              handleOnChange={handleOnChange}
              className={`input ${
                errors["descripcionMenu"] ? "input_error" : ""
              }`}
              errorMessage={errors["descripcionMenu"]}
            />
          </>
        </InputsGroup>
        <InputsGroup>
          <>
            <Inputs
              id={"descripcion"}
              label={"Descripción"}
              type={"text"}
              value={item?.descripcion}
              handleOnChange={handleOnChange}
              className={`input ${errors["descripcion"] ? "input_error" : ""}`}
              errorMessage={errors["descripcion"]}
            />
            <Inputs
              id={"idTipoReporte"}
              label={"Tipo Reporte"}
              type={"select"}
              value={item?.idTipoReporte}
              handleOnChange={handleOnChange}
              options={reportTypes}
              className={`input ${
                errors["idTipoReporte"] ? "input_error" : ""
              }`}
              errorMessage={errors["idTipoReporte"]}
            />
          </>
        </InputsGroup>
        <InputsGroup
          visible={item?.idTipoReporte != 2 && item?.idTipoReporte != 3}
        >
          <>
            <Inputs
              id={"rutaReporte"}
              label={"Ruta Reporte"}
              type={"text"}
              value={item?.rutaReporte}
              labelPercent={12}
              handleOnChange={handleOnChange}
              className={`input ${errors["rutaReporte"] ? "input_error" : ""}`}
              errorMessage={errors["rutaReporte"]}
            />
          </>
        </InputsGroup>
        <InputsGroup
          visible={item?.idTipoReporte == 2 || item?.idTipoReporte == 3}
        >
          <>
            <Inputs
              id={"idWorkspace"}
              label={"workspaceid"}
              type={"text"}
              value={item?.idWorkspace}
              handleOnChange={handleOnChange}
              className={`input ${errors["idWorkspace"] ? "input_error" : ""}`}
              errorMessage={errors["idWorkspace"]}
            />
            <Inputs
              id={"idReport"}
              label={"reportid"}
              type={"text"}
              value={item?.idReport}
              handleOnChange={handleOnChange}
              className={`input ${errors["idReport"] ? "input_error" : ""}`}
              errorMessage={errors["idReport"]}
            />
          </>
        </InputsGroup>
        <InputsGroup>
          <>
            <Inputs
              id={"imagen"}
              label={"Logo"}
              type={"file"}
              value={item?.imagen}
              accept={".jpeg,.jpg,.png"}
              labelPercent={13}
              handleOnChange={handleOnChange}
              className={`input ${errors["image"] ? "input_error" : ""}`}
              errorMessage={errors["image"]}
            />
          </>
        </InputsGroup>
        <InputsGroup>
          <>
            <Inputs
              id={"idVistaPadre"}
              label={"Vista Padre"}
              type={"select"}
              value={item?.idVistaPadre}
              handleOnChange={handleOnChange}
              options={reportsParent}
              className={`input ${errors["idVistaPadre"] ? "input_error" : ""}`}
              errorMessage={errors["idVistaPadre"]}
            />
            <Inputs
              id={"idEstatus"}
              label={"Estatus"}
              type={"select"}
              value={item?.idEstatus}
              handleOnChange={handleOnChange}
              options={status}
              className={`input ${errors["idEstatus"] ? "input_error" : ""}`}
              errorMessage={errors["idEstatus"]}
            />
          </>
        </InputsGroup>
      </>
    );
  };

  return <>{renderInputs()}</>;
};

export default FormReporte;
